define('OutSystems/ClientRuntime/PublicApiHelper',["require", "exports", "./BuiltinFunctions", "./Public"], function (require, exports, BuiltinFunctions, Public_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PublicApiHelper = void 0;
    var PublicApiHelper = (function () {
        function PublicApiHelper(_model, _navigationContext) {
            this._model = _model;
            this._navigationContext = _navigationContext;
        }
        Object.defineProperty(PublicApiHelper.prototype, "BuiltinFunctions", {
            get: function () {
                return BuiltinFunctions;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Validation", {
            get: function () {
                if (!this._validation) {
                    this._validation = new Public_1.Validation(this._model);
                }
                return this._validation;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "FeedbackMessage", {
            get: function () {
                return Public_1.FeedbackMessage;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Device", {
            get: function () {
                return Public_1.Device;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Security", {
            get: function () {
                return Public_1.Security;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "ApplicationLifecycle", {
            get: function () {
                return Public_1.ApplicationLifecycle;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "ApplicationContext", {
            get: function () {
                return Public_1.ApplicationContext;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "ApplicationLoad", {
            get: function () {
                return Public_1.ApplicationLoad;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Navigation", {
            get: function () {
                if (!this._navigation) {
                    this._navigation = new Public_1.Navigation(this._navigationContext);
                }
                return this._navigation;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Logger", {
            get: function () {
                return Public_1.Logger;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "View", {
            get: function () {
                if (!this._view) {
                    this._view = new Public_1.View(this._model);
                }
                return this._view;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(PublicApiHelper.prototype, "Branding", {
            get: function () {
                return Public_1.Branding;
            },
            enumerable: false,
            configurable: true
        });
        return PublicApiHelper;
    }());
    exports.PublicApiHelper = PublicApiHelper;
});
//# sourceMappingURL=PublicApiHelper.js.map;
